import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import TaskCMNHeaderEditor from "./TaskCMNHeaderEditor"

const TaskShortHand = (props)=>{
    const { formObject, viewData, dynamicViewData, ...restProps } = props;

    const dashDocId = dynamicViewData ?dynamicViewData.action.actionParam.dsh_docid:0;
    const dashWrksid = dynamicViewData ?dynamicViewData.action.actionParam.dsh_wrksid:0;
    const dashRowId = dynamicViewData ?dynamicViewData.action.actionParam.dshv_rowId:0;

    return(
        <FormDialog dynamicViewData={dynamicViewData} onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam:{showModeID:"sh", dsh_docid:dashDocId, 
            dsh_wrksid:dashWrksid, dshv_rowId:dashRowId } }}
            formStyle={{ width: '715px' }}
            contentStyle={{ height: '460px',overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Task Header' />}
            formObject={formObject} >

            <TaskCMNHeaderEditor formObject={formObject} viewData={viewData} {...restProps}  />

        </FormDialog>
    )
}

export default withView(TaskShortHand, "taskComp", "")
